module.exports = __webpack_public_path__ + "img/freeze.4b970abe.svg";